<template>
  
  <div class="flex flex-column pl-2 pr-2">

      <div class="mt-2 mb-2 flex align-items-center flex-column md:justify-content-between md:flex-row">
        <h2 class="">BALÍKY PRODUKTOV</h2>
        <div class="flex align-items-center">
            <router-link to="/mod-stock/packages/0" class="mr-2">
              <PrimevueButton label="Pridať balík" severity="success" icon="pi pi-plus" text raised class="uppercase"/>
            </router-link>
            <router-link to="/mod-stock/scan-item" class="mr-2">
              <PrimevueButton label="Skenovať balík" severity="success" icon="pi pi-camera" text raised class="uppercase"/>
            </router-link>
        </div>
      </div>
      <DataTable
          
          lazy paginator :rows="this.pagination.rows"
          @page="onPage"
          :first="this.pagination.first"
          :loading="loading"
          :totalRecords="this.pagination.totalRecords"
          dataKey="id"
          :value="this.packages"
          v-model:filters="filters"
          @filter="onFilter"
          filterDisplay="row" 
          :globalFilterFields="globalFilterFields"
          stripedRows
          row-hover
          scrollable
          v-model:selection="this.selectedPackage"

          selectionMode="single"
          :metaKeySelection="false"
         
          tableStyle="min-width: 10rem"
          :virtualScrollerOptions="{ itemSize: 40 }"
          :scrollHeight="`${this.vh - 420}px`"
          
          v-model:expandedRows="expandedRows"
      >
      <!--
       @rowSelect="showDetail(this.selectedPackage.id)"
        
       <template #header>
          <div class="flex justify-content-end">
            <IconField iconPosition="left">
              <InputIcon>
                <i class="pi pi-search mr-2"/>
              </InputIcon>
              <InputText v-model="filters['global'].value" placeholder="Vyhľadať" @keydown.enter="onFilter"/>
            </IconField>
          </div>
        </template>

        
        <Column header="">
          <template #body="slotProps">
              <img :src="`${slotProps.data.product.image}`" :alt="slotProps.data.product.image" class="shadow-4 border-round" width="64" />
          </template>
        </Column>
        -->
        <Column expander style="width: 1rem" />
        <Column header="" style="min-width: 1%">
          <template #body="slotProps">
            <div
              class="color-box"
              :style="{ backgroundColor: slotProps.data.color.colorHash }"
            ></div>
          </template>
        </Column>

        <Column field="code" header="Kód">
                
          <template #body="slotProps">
            {{ slotProps.data.code }}
          </template>
         
        </Column>

        <Column field="codes" header="Produkty">
                
          <template #body="slotProps">
            {{ slotProps.data.listOfProd }}
          </template>
         
        </Column>


        <Column field="numberOfPieces" header="Počet kusov">

          <template #body="slotProps">
            {{ slotProps.data.numberOfPieces }}
          </template>
          <!--
          <template #filter="{ filterModel, filterCallback }">
            <InputNumber v-model="filterModel.value" :useGrouping="false" fluid @keydown.enter="filterCallback()" class="p-column-filter"
                       placeholder="Hľadať" style="min-width: 4rem"/>
          </template>
          -->
        </Column>

        <Column field="numberOfReservedPieces" header="Rezerv.">
        </Column>

        <Column field="location" header="Umiestnenie"
                filterField="location"
                :showFilterMenu="false"
                :filterMenuStyle="{ width: '2rem' }" style="min-width: 2%">
          <template #body="slotProps">
            {{ slotProps.data.location }}
          </template>
          <template #filter="{ filterModel, filterCallback }">
            <InputText v-model="filterModel.value" type="text" @keydown.enter="filterCallback()" class="p-column-filter"
                       placeholder="Hľadať" style="min-width: 2%"/>
          </template>
        </Column>

        <Column header="" >
          <template #body="slotProps">
            <PrimevueButton type="button" v-tooltip.top="{ value: 'Editácia balíka' }" icon="pi pi-pencil" 
              class="pack" @click="showDetail(slotProps.data.id)" text size="small"/>
          </template>
        </Column>

        <Column header="">
          <template #body="slotProps">

            <PrimevueButton type="button" v-tooltip.top="{ value: 'Vymazanie balíka' }" icon="pi pi-trash" 
               class="pack" @click="confirmDelete(slotProps.data.id)" text severity="danger" size="small"/>

          </template>
        </Column>

        <template #expansion="slotProps">
          <div class="p-1">
              
              <DataTable :value="slotProps.data.packages" >
                <Column header="">
                  <template #body="slotProps">
                      <img :src="`${slotProps.data.product.image}`" :alt="slotProps.data.product.image" class="shadow-4 border-round" width="64" />
                  </template>
                </Column>
                <Column field="product.category.name" header="Kategória" sortable></Column>
                <Column field="product.code" header="Kód" sortable></Column>
                <Column field="product.name" header="Názov" sortable></Column>                
                <Column field="product.length" header="Dĺžka" ></Column>
                <Column field="numberOfPieces" header="Počet kusov" sortable></Column>
                <Column field="numberOfReservedPieces" header="Rezerv."></Column>
                <Column field="numberOfFreePieces" header="Voľné" sortable>
                  <template #body="slotProps">
                    <div class="text-green-500"> {{slotProps.data.numberOfFreePieces}} </div>
                  </template>
                </Column>
              </DataTable>
          </div>
        </template>
      </DataTable>
  </div>
  <ConfirmDialog></ConfirmDialog>

</template>

<script lang="ts">

//import IconField from 'primevue/iconfield';
import {store} from "@/components/store";
import Security from "@/components/security";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import router from "@/router";
import {FilterMatchMode} from "primevue/api";
//import PrimevueSelect from "primevue/dropdown";
//import InputIcon from "primevue/inputicon";
import notie from "notie/dist/notie";
import PrimevueButton from "primevue/button";
import Utils from './utils';

export default {
  components: {
    DataTable,
    Column,
    //IconField,
    //PrimevueSelect,
    //InputIcon,
    PrimevueButton

  },
  name: "PackageList",
  data() {
    return {
      store,
      vh: 0,
      expandedRows: {},
      selectedPackage: null,
      packages: [],
      filters: {
        global: {value: null, matchMode: FilterMatchMode.CONTAINS},
        productNumber: {value: null, matchMode: FilterMatchMode.CONTAINS},
        productName: {value: null, matchMode: FilterMatchMode.CONTAINS},
        categoryName: {value: null, matchMode: FilterMatchMode.CONTAINS},
        location: {value: null, matchMode: FilterMatchMode.CONTAINS},
        //numberOfPieces: {value: null, matchMode: FilterMatchMode.EQUALS},
      },
      filterFields: [  {field: 'Product__Code',value: ""},
                       {field: 'Product__CategoryId__Name',value: ""},
                       {field: 'Product__Name',value: ""},
                       {field: 'Location',value: ""},                       
                       //{field: 'NumberOfPieces',value: ""}
                    ],
      globalFilterFields: ['Product__Code', 'Product__Name', 'Product__CategoryId__Name'],
      categories: [],
      loading: true,
      pagination: {
        first: 0,
        rows: 100,
        totalRecords: 0, // Total number of records for pagination
        filters: {},
      },
    }
  },

  computed: {
    Utils() {
      return Utils
    },
 
  },

  beforeMount() {
    if (Security.requireToken()){
      store.selectModul = this.$route.path.split("/")[1]
      this.setDynamicHeight(); 
      // Aktualizácia výšky pri zmene veľkosti okna
      window.addEventListener("resize", this.setDynamicHeight);
      
      this.initFilters()

      fetch(store.Api_url + "/v1/category?query=deleted:0", Security.requestOptions("GET"))
          .then((response) => response.json())
          .then((responseData) => {
            if (responseData.error) {
                notie.alert({
                      type: 'error',
                      text: "Zoznam kategórií sa nepodarilo načítať: " + responseData.message,
                      position: "top"
                    })           
            } else {
              //console.log(responseData);
              this.categories = responseData.data
             
              this.loading = false
            }
          })
          .catch((error) => {
            notie.alert({
                      type: 'error',
                      text: "Zoznam kategórií sa nepodarilo načítať: " + error,
                      position: "top"
                    })           
      });
      
      this.loadComponent()
    }
  },
  
  beforeUnmount() {

    window.removeEventListener("resize", this.setDynamicHeight);
  },

  methods: {
    setDynamicHeight() {
      this.vh = window.innerHeight; // Nastavenie viditeľnej výšky
    },
 
    showDetail(mPackId:number) {
      router.push('/mod-stock/packages/' + String(mPackId))
    },
    confirmDelete(mPackId:number) {
      this.$confirm.require({
          message: 'Naozaj chcete vymazať balík?',
          header: 'Vymazanie balíka',
          icon: 'pi pi-exclamation-triangle',
          acceptLabel: "Áno",
          rejectLabel: "Nie",

          accept: () => {
            this.deleteMultiPack(mPackId)
          },

      });
    },

    deleteMultiPack(mPackId:number){
      //if(confirm("Naozaj chcete ODSTRÁNIŤ objednávku?")){
        Security.requireToken();
        fetch(store.Api_url + "/v1/multi-pack/" + String(mPackId), Security.requestOptions("DELETE"))
            .then((response) => response.json())
            .then((responseData) => {
              if (responseData.error) {
                //console.log("error:", responseData.message);
                this.$emit('error', responseData.message);
                notie.alert({
                    type: 'error',
                    text: "Balík sa nepodarilo odstrániť: " + responseData.message,
                    position: "top"
                  })           
              } else {

                //this.packages = responseData.data;
                notie.alert({
                  type: 'success',
                  text: "Balík bol odstránený",
                  position: "bottom"
                })
                this.initFilters()
                this.addStockMovement(mPackId)
                this.loadComponent()
              }
            })
            .catch((error) => {
              alert('Chyba pri odstránení balíka: ' + error)
            })
      //}
    },

    onPage(event) {
        this.pagination.first = event.first; // PrimeVue page is zero-based; adjust if your API is 1-based

        this.loadLazyData(this.store.basicUrlFilterProducts,this.pagination);
    },

    addStockMovement(id:number){
      let dataMovement = {package:{id:id},
                              action:"",
                              user:store.user,
                              color:"",
                         }
                         console.log('ADD Movement',id);
      //if (this.typeOfMultiPackAction == "DEL"){
         dataMovement.action = Utils.getDelTextAction("Balík")
         Utils.addStockMovement(dataMovement,"package_id","DEL",id)

      //}

    },

    loadComponent(){

      this.pagination.first = 0
      this.pagination.totalRecords = 0

      this.loadLazyData(this.store.basicUrlFilterProducts,this.pagination)

    },
    initFilters(){
        this.pagination.filters.filterFields = this.filterFields
        this.pagination.filters.global = ""
        this.pagination.filters.table = "multi_pack"
        this.pagination.filters.globalFilterFields = this.globalFilterFields;

    },
    onFilter(event) {
        if(event.filters){
          //console.log("Event:", event);
           this.pagination.filters.filterFields = [ {field: 'Product__Code',value: event.filters.productNumber.value ? event.filters.productNumber.value : ""},
                                                    {field: 'Product__Name',value: event.filters.productName.value ? event.filters.productName.value: ""},
                                                    {field: 'Product__CategoryId__Name',value: event.filters.categoryName.value ? event.filters.categoryName.value["name"]: ""},
                                                    {field: 'Location',value: event.filters.location.value ? event.filters.location.value: ""},
                                                    //{field: 'NumberOfPieces',value: event.filters.numberOfPieces.value ? event.filters.numberOfPieces.value : ""}
                                                  ];
           this.pagination.filters.global = event.filters.global.value                                        
        }else{
          this.pagination.filters.filterFields = this.filterFields
          this.pagination.filters.global = this.filters.global.value
          //console.log("Filters:", this.pagination.filters);
        }
        this.pagination.filters.globalFilterFields = this.globalFilterFields;
        this.pagination.first = 0;  // Reset to the first page
        //console.log("Filters:", this.pagination.filters);
        this.loadLazyData(this.store.basicUrlFilterProducts,this.pagination);
    },

    loadLazyData(route,params) {
      this.loading = true;

      let queryParams = `&limit=${params.rows}&offset=${(params.first)}`;

      fetch(`${store.Api_url}${route}${queryParams}`, Security.requestOptions("POST",params.filters))
          .then(response => response.json())
          .then(responseData => {
            if (responseData.error) {
              //console.error("error:", responseData.message);
              //this.$emit('error', responseData.message);
              notie.alert({
                    type: 'error',
                    text: "Zoznam balíkov sa nepodarilo načítať " + responseData.message,
                    position: "top"
                  })           
            } else {
              if(responseData.data){
                  this.packages = responseData.data;
                  this.packages.forEach((mpack) => {
                    let listOfCodes = ""
                    mpack.packages.forEach((pack) => {
                      listOfCodes = listOfCodes +","+ pack.product.code
                      pack.numberOfFreePieces = pack.numberOfPieces - pack.numberOfReservedPieces
                    })
                    listOfCodes = listOfCodes.replace(/^,/, '')
                    mpack.listOfProd = listOfCodes
                  })
                  

                }else{
                    notie.alert({
                    type: 'info',
                    text: "Zoznam balíkov je prázdny",
                    position: "top"
                  })
                  this.packages = []
                }
              this.pagination.totalRecords = responseData.totalRecords;
              this.loading = false;
            }
          })
          .catch(error => {
            //alert('Error fetching data: ' + error);
            notie.alert({
                    type: 'error',
                    text: "Chyba pri načítaní balíkov: "+error,
                    position: "top"
                  })
            this.loading = false;
          });
    }
  }

}
</script>

<style>


</style>